import { z } from "zod";

// Login second step (passport-web → POST /auth/mfa/verify). `mfa_token` is the short-lived limited JWT from
// the login 202 body. Exactly one of `code` / `recovery_code` is required — enforced server-side (a constraint
// JSON Schema can't express), so both are nullable+optional here. `code` is the 6-digit emailed OTP; a recovery
// code is a high-entropy break-glass string (with or without its display dash).
export const mfaVerifyRequestSchema = z.object({
  mfa_token: z.string().min(1),
  code: z.string().regex(/^\d{6}$/, "Enter the 6-digit code").nullable().optional(),
  recovery_code: z.string().min(8).max(20).nullable().optional(),
});
